import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import {
	Placeholder,
	ButtonGroup,
	__experimentalToggleGroupControl as ToggleGroupControl,
	__experimentalToggleGroupControlOption as ToggleGroupControlOption,
	Button,
	Dashicon,
	Modal,
	TabPanel,
	TabList,
	Tab,
	PanelRow,
	PanelColumn,
	RangeControl,
	BaseControl,
} from '@wordpress/components';
import InspectorResponsiveLabel, {
	getCurrentMedia,
	valueToMediaValue,
	mediaValueToValue,
} from '../inspector-responsive-label';
import InspectorDashCustomIcon from '../inspector-dash-custom-icon';
import { toCamelCase } from '../../functions';

const InspectorSelectButton = ( props ) => {
	const {
		label,
		options,
		value,
		onChange,
		iconButton,
		isResetButton = false,
		isMedia = true,
		isUnit = false,
	} = props;
	// const [currentMedia, setCurrentMedia] = useState(getCurrentMedia());

	// useEffect(() => {
	//   const handler = (e) => {
	//     setCurrentMedia(e.detail);
	//   };
	//   window.addEventListener('alphaBlocksMediaChange', handler);
	//   return () => {
	//     window.removeEventListener('alphaBlocksMediaChange', handler);
	//   };
	// }, []);

	const getLabel = ( iconButton, item ) => {
		return iconButton ? (
			<InspectorDashCustomIcon icon={ item.iconName ?? item?.icon } />
		) : (
			item.label
		);
	};

	return (
		<BaseControl
			// label={label??"Default"}
			id="alpha-accordion-type"
			__nextHasNoMarginBottom
		>
			<BaseControl.VisualLabel
				style={ { textTransform: 'none', fontSize: '14px' } }
			>
				{ label ?? 'Default' }
			</BaseControl.VisualLabel>

			{ /* <InspectorResponsiveLabel label={label??"Default Label"} isResetButton={isResetButton} isMedia={isMedia} isUnit={isUnit} /> */ }

			<ToggleGroupControl
				id="alpha-accordion-type"
				className="flex w-full gap-0 p-0"
				value={ value }
				style={ { padding: '0px' } }
				onChange={ ( val ) => onChange( val ) }
				isBlock
				__nextHasNoMarginBottom={ true }
				__next40pxDefaultSize={ true }
			>
				{ options?.map( ( item, key ) => (
					<ToggleGroupControlOption
						className="flex-1 text-center justify-center"
						key={ key }
						// isLarge
						// isSecondary={
						//   value !==
						//     item.value
						// }
						// isPrimary={
						//   value ===
						//     item.value
						// }
						value={ item?.value }
						label={ getLabel( iconButton, item ) }
						// onClick={() =>
						//   onChange(item.value)
						// }
					></ToggleGroupControlOption>
				) ) }
			</ToggleGroupControl>
		</BaseControl>
	);
};

export default InspectorSelectButton;
